import { useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import Card, { CardHeader, CardTitle, CardContent } from '../components/UI/Card'
import Button from '../components/UI/Button'
import LoadingSpinner from '../components/UI/LoadingSpinner'
import api from '../services/api'

export default function PaymentReturn() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const orderId = params.get('order_id')
  const [attempt, setAttempt] = useState(0)

  const { data, isLoading, isError, error } = useQuery(
    ['cashfree-confirm', orderId, attempt],
    () => api.post('/payments/cashfree/confirm', { order_id: orderId }).then((response) => response.data),
    { enabled: Boolean(orderId), retry: false }
  )

  const payment = data?.data?.payment
  const paid = payment?.payment_status === 'completed'

  return (
    <div className="max-w-lg mx-auto py-10">
      <Card>
        <CardHeader>
          <CardTitle>Payment status</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {!orderId && <p className="text-sm text-secondary-700">No payment reference was returned.</p>}
          {orderId && isLoading && (
            <div className="flex items-center gap-2 text-sm text-secondary-700">
              <LoadingSpinner size="sm" />
              Checking Cashfree for this payment.
            </div>
          )}
          {isError && (
            <p className="text-sm text-red-600">{error?.response?.data?.message || 'Could not confirm the payment.'}</p>
          )}
          {payment && (
            <p className="text-sm text-secondary-700">
              {paid
                ? 'Payment completed. The subscription is now active.'
                : `Payment is ${payment.payment_status}. If you just finished checkout, check again in a moment.`}
            </p>
          )}
          <div className="flex gap-3">
            <Button type="button" variant="outline" onClick={() => setAttempt((value) => value + 1)} disabled={!orderId || isLoading}>
              Check again
            </Button>
            <Button type="button" onClick={() => navigate('/organizations')}>
              Back to organizations
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
